import { global } from "../../constants";

export const data = {
  banner: {
    base: "Servicios",
    background: global.banner + "ofac.webp",
    title: "Licencias OFAC",
    crumb: "Licencias OFAC",
  },
  icon: "fa-solid fa-file-shield",
  shortDescription:
    "Guía integral para la solicitud de licencias específicas ante la OFAC: cumplimiento regulatorio para transacciones con PDVSA y el sector energético venezolano.",
  title: "Solicitud de Licencia de la OFAC",
  features: {
    title: "Solicitud de Licencia de la OFAC",
    deliverables: "Entregables",
    reqDocuments: "Documentos Requeridos",
    subtitle:
      "Resumen y guía de cumplimiento para transacciones con el sector energético de Venezuela y operaciones vinculadas con PDVSA.",
    description:
      "Antes de presentar una solicitud de licencia específica, la empresa debe verificar si sus actividades ya están cubiertas por Licencias Generales emitidas por la OFAC. Incluso cuando una operación pudiera encajar en una Licencia General, en la práctica PDVSA suele exigir a sus contrapartes una licencia específica antes de concretar la transacción. Por eso conviene estructurar la solicitud con criterios claros de cobertura, identificación de partes, alcance operativo, medios de pago y soporte documental.",
    viewDetail: "Ver Detalles",
    feats: [
      {
        key: "licencias-generales",
        title: "Verificación de Licencias Generales aplicables",
        summary:
          "Determinamos si la actividad propuesta ya está cubierta por una Licencia General vigente para evitar un trámite innecesario o mal enfocado.",
        details:
          "Evaluamos la naturaleza de la operación frente a las Licencias Generales que pueden resultar relevantes para el sector energético venezolano, incluyendo supuestos vinculados con compra y exportación de petróleo, suministro de bienes, tecnología o servicios para exploración y producción, venta de diluyentes de origen estadounidense y negociación de contratos contingentes. El análisis distingue entre actividades autorizadas, limitaciones expresas y escenarios donde sigue siendo necesaria una licencia específica independiente.",
        deliverables: [
          "Análisis de cobertura bajo Licencias Generales vigentes",
          "Recomendación fundamentada entre licencia general y licencia específica",
          "Informe de riesgo regulatorio OFAC",
        ],
        requiredDocs: [
          "Descripción de la actividad o transacción propuesta",
          "Fecha de constitución de la empresa estadounidense",
          "Naturaleza del bien, servicio o tecnología a proveer",
        ],
        icon: "fa-solid fa-shield-halved",
        image: global.ofac + "1.webp",
      },
      {
        key: "solicitante",
        title: "Información del solicitante en EE. UU.",
        summary:
          "Recopilamos y estructuramos la información corporativa del solicitante conforme a los criterios exigidos por la OFAC.",
        details:
          "La solicitud requiere identificar con precisión al solicitante: nombre legal y nombres comerciales, estado y fecha de constitución, sede principal y domicilio social, número de identificación fiscal federal, identidad de directivos y responsables, propietarios beneficiarios con participación relevante, organigrama corporativo y cualquier filial o empresa asociada extranjera que participe en la operación.",
        deliverables: [
          "Ficha corporativa completa del solicitante",
          "Organigrama corporativo estructurado",
          "Listado de propietarios beneficiarios y directivos",
        ],
        requiredDocs: [
          "Certificado de constitución y estatutos sociales",
          "Documentos de identificación de directivos y accionistas",
          "Registros corporativos de filiales y empresas relacionadas",
        ],
        icon: "fa-solid fa-building",
        image: global.ofac + "2.webp",
      },
      {
        key: "contraparte-terceros",
        title: "Identificación de contraparte y terceros involucrados",
        summary:
          "Mapeamos a PDVSA, sus filiales, intermediarios, bancos, transportistas y demás actores que intervienen en cualquier fase de la operación.",
        details:
          "La solicitud debe identificar de forma exhaustiva a la contraparte principal y a todos los terceros participantes, incluyendo filiales, empresas conjuntas, representantes, agentes, intermediarios, instituciones financieras, empresas de transporte o logística, subcontratistas, proveedores de servicios y organismos del Gobierno de Venezuela con cualquier rol dentro de la transacción.",
        deliverables: [
          "Mapa de partes involucradas en la transacción",
          "Análisis de vinculación con entidades sancionadas",
          "Informe de debida diligencia sobre terceros",
        ],
        requiredDocs: [
          "Contratos o comunicaciones con PDVSA o sus filiales",
          "Datos de instituciones financieras y cuentas bancarias",
          "Información de proveedores, transportistas y agentes involucrados",
        ],
        icon: "fa-solid fa-sitemap",
        image: global.ofac + "3.webp",
      },
      {
        key: "naturaleza-alcance",
        title: "Naturaleza y alcance de la operación",
        summary:
          "Definimos con precisión qué bienes, servicios o tecnología estarán involucrados, su duración, valor y alcance territorial u operativo.",
        details:
          "Se documenta la descripción detallada de los bienes, servicios o tecnología a proveer o recibir de PDVSA, su clasificación sectorial, el origen de la relación comercial, la existencia o no de contrato firmado, el valor estimado de la operación, la duración del compromiso, los hitos de ejecución, el calendario de entregas y las ubicaciones geográficas donde se prestará el servicio o se ejecutará la actividad.",
        deliverables: [
          "Descripción narrativa de la operación para la solicitud",
          "Cronograma e hitos del contrato",
          "Resumen ejecutivo del alcance técnico y comercial",
        ],
        requiredDocs: [
          "Borrador o contrato firmado con PDVSA",
          "Especificaciones técnicas de bienes o servicios",
          "Cronograma preliminar o condiciones comerciales pactadas",
        ],
        icon: "fa-solid fa-file-contract",
        image: global.ofac + "4.webp",
      },
      {
        key: "condiciones-pago",
        title: "Condiciones de pago y flujo financiero",
        summary:
          "Describimos cómo circularán los pagos, en qué moneda, mediante qué instrumentos y con qué bancos o intermediarios financieros.",
        details:
          "La OFAC suele exigir una explicación clara del mecanismo de pago, ya sea transferencia, carta de crédito, compensación, trueque o pago en especie. También se documentan la moneda de pago, eventuales mecanismos de conversión, cuentas receptoras y emisoras, bancos intervinientes, códigos SWIFT y cualquier estructura financiera asociada a la operación.",
        deliverables: [
          "Diagrama de flujo de pagos con instituciones identificadas",
          "Resumen del mecanismo de pago y moneda aplicable",
          "Matriz de bancos, cuentas y participantes financieros",
        ],
        requiredDocs: [
          "Datos bancarios completos de todas las entidades de pago",
          "Instrucciones de pago o borradores de cláusulas financieras",
          "Información de bancos corresponsales y códigos SWIFT",
        ],
        icon: "fa-solid fa-money-bill-transfer",
        image: global.ofac + "5.webp",
      },
      {
        key: "geografia-documentacion",
        title: "Ámbito geográfico, logístico y documentación de apoyo",
        summary:
          "Organizamos el componente territorial y logístico de la operación junto con el expediente documental que respaldará la solicitud.",
        details:
          "Se debe indicar dónde se prestarán los servicios, cuáles serán los puertos, rutas o países involucrados y si existirá exportación de petróleo o derivados a terceros países. Además, se consolida el expediente de apoyo con documentos corporativos, contrato o borrador contractual, especificaciones técnicas, diagrama de flujo de pagos, licencias OFAC previas y traducciones certificadas cuando corresponda.",
        deliverables: [
          "Mapa logístico de la operación con puertos, rutas y países",
          "Expediente completo de anexos organizado y numerado",
          "Checklist de documentación para la presentación ante la OFAC",
        ],
        requiredDocs: [
          "Documentación de rutas de transporte y puertos involucrados",
          "Licencias OFAC previas del solicitante, si las hubiera",
          "Traducciones certificadas al inglés de los documentos de soporte",
        ],
        icon: "fa-solid fa-earth-americas",
        image: global.ofac + "6.webp",
      },
    ],
  },
  ctaText: "Solicitar asesoría OFAC",
  ctaLink: "/contacto?servicio=licencia-ofac",
};
